var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCorrectiveActionPreventionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66732 2.0013V0.667969H5.00065V2.0013H9.00065V0.667969H10.334V2.0013H13.0007C13.3689 2.0013 13.6673 2.29978 13.6673 2.66797V6.0013H12.334V3.33464H10.334V4.66797H9.00065V3.33464H5.00065V4.66797H3.66732V3.33464H1.66732V12.668H5.66732V14.0013H1.00065C0.632464 14.0013 0.333984 13.7028 0.333984 13.3346V2.66797C0.333984 2.29978 0.632464 2.0013 1.00065 2.0013H3.66732ZM10.334 8.0013C8.86125 8.0013 7.66732 9.19524 7.66732 10.668C7.66732 12.1407 8.86125 13.3346 10.334 13.3346C11.8067 13.3346 13.0007 12.1407 13.0007 10.668C13.0007 9.19524 11.8067 8.0013 10.334 8.0013ZM6.33398 10.668C6.33398 8.45884 8.12485 6.66797 10.334 6.66797C12.5431 6.66797 14.334 8.45884 14.334 10.668C14.334 12.8771 12.5431 14.668 10.334 14.668C8.12485 14.668 6.33398 12.8771 6.33398 10.668ZM9.66732 8.66797V10.9441L11.1959 12.4727L12.1387 11.5299L11.0007 10.3918V8.66797H9.66732Z",
    fill: "#26ABE1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCorrectiveActionPreventionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CorrectiveActionPreventionIcon.87ada907.svg";
export { ForwardRef as ReactComponent };